module.exports = "<div [innerHTML]=\"pageConfig.PromotionWhatIsIDme | safeHtml\"></div>\r\n\r\n"